import "./Modal.scss";

import React, { Component } from "react";

import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import Button from "./Button";

export default class Modal extends Component {
  render() {
    const { title, children, close, withCloseButton = false } = this.props;

    return (
      <React.Fragment>
        <button className="Modal-overlay" onClick={close} />

        <div className="Modal" data-testid="modal">
          <div className="Modal__title">
            <h4>{title}</h4>
            {withCloseButton && (
              <Button
                onClick={close}
                buttonType="negative"
                className="Modal__close-button"
              >
                <CloseIcon />
              </Button>
            )}
          </div>

          <div className="Modal__content">{children}</div>
        </div>
      </React.Fragment>
    );
  }
}
